import type { z } from "zod";

import type { loginSchema } from "~/screens/Login";
import type { ServiceResponse } from "./axios";
import { api, refreshApi } from "./axios";
import type { AuthResponse, RefreshResponse } from "./types";

export type LoginFormData = z.infer<typeof loginSchema>;
export const login = async (data: LoginFormData): Promise<AuthResponse> => {
  const response = await api.post<ServiceResponse<AuthResponse>>(
    "/auth/login/",
    data,
  );
  return response.data.data;
};

export const refreshAuth = async (): Promise<RefreshResponse> => {
  const response =
    await refreshApi.post<ServiceResponse<RefreshResponse>>("/auth/refresh");
  return response.data.data;
};
